import React, {useContext, useState, useEffect} from 'react';
import {Context} from '../../context';
import LabelAndInput from '../UI/LabelAndInput';
import Button from '../UI/Button';

function SecurityQuestion(props) {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [errors, setErrors] = useState([]);
  const {accessRequestId, setSecurityQuestionPassed} = props;
  const {
    localeText,
    token,
    transitionGetSecurityQuestion,
    transitionAnswerSecurityQuestion
  } = useContext(Context);

  useEffect(() => {
    (async () => {
      const data = {accessRequestId};
      const res = await transitionGetSecurityQuestion(data);

      props.handleErrors(res, setErrors);

      if (!res?.data?.getSecurityQuestion?.question) {
        return;
      }

      setQuestion(res.data.getSecurityQuestion.question);
    })();
  }, []);

  const answerSecurityQuestionChallenge = async e => {
    e.preventDefault();
    const data = {accessRequestId, answer};
    const res = await transitionAnswerSecurityQuestion(data);

    props.handleErrors(res, setErrors);

    if (!res?.data?.sendSecurityAnswer) {
      return;
    }

    setSecurityQuestionPassed(true);
  };
  return (
    <form
      className='w-96 gap-1 flex flex-col'
      onSubmit={answerSecurityQuestionChallenge}
    >
      <LabelAndInput
        inputId='security-question'
        name='security-question'
        label={question}
        type='text'
        value={answer}
        onChange={e => setAnswer(e.target.value)}
        required
      />
      {errors &&
        errors.map((error, index) => (
          <div key={index} className='text-red text-xl my-4'>
            {localeText(error.slug, error.default)}
          </div>
        ))}
      <Button
        buttonId='migration-continue'
        className='mt-4'
        type='submit'
        disabled={!token}
      >
        {localeText('rw_button_continue', 'Continue')}
      </Button>
    </form>
  );
}

export default SecurityQuestion;
